import { useFormContext } from 'react-hook-form';

import { fetchUserReason } from '@jobandtalent/auth-api-client-v2';
import { InputText } from '@jobandtalent/design-system';

import FormInput from 'src/components/FormInput/FormInput';
import SavedReason from 'src/components/SavedReason/SavedReason';
import Section from 'src/components/Section/Section';

const CompanyUserInfoSection = ({ userId, canReadReason, readOnly = false }: { userId?: number; canReadReason?: boolean; readOnly?: boolean }) => {
  const { register, formState: { errors } } = useFormContext(); // Use useFormContext to get register and errors.

  return (
    <Section icon="info" title="User info">
      <FormInput label="UID">
        <InputText disabled {...register('id', { required: true })} />
      </FormInput>
      <FormInput label="User name">
        <InputText disabled={readOnly} error={!!errors.name} {...register('name', { required: true })} />
      </FormInput>
      <FormInput label="User email">
        <InputText disabled error={!!errors.email} {...register('email', { required: true })} />
      </FormInput>
      {userId !== undefined && <SavedReason canReadReason={canReadReason} loadReason={() => fetchUserReason(userId)} />}
    </Section>
  );
};

export default CompanyUserInfoSection;
